import { HttpService } from './../../api/http.service';
import * as angular from 'angular';
import { IPromise } from 'angular';

export interface IInternalImageData {
    url: string;
    token: string;
    width: number;
    height: number;
}

export class ImageService {
    static $inject = ['$q', 'http', 'imageServiceUrl'];

    constructor(
        private $q: ng.IQService,
        private http: HttpService,
        private imageServiceUrl: string,
    ) { }

    getInternalImageURL(url: string): IPromise<IInternalImageData> {
        let deferred = this.$q.defer<IInternalImageData>();
        let response = this.http.post<IInternalImageData>(this.getImageUrl(), { Uri:  url} );

        if (response.toString() === 'cancel') {
            return null;
        }
        deferred.resolve(response);
        return deferred.promise;
    }

    private getImageUrl(): string {
        return this.imageServiceUrl + 'Image/ByUrl';
    }
}

angular
    .module('app.common')
    .service('imageService', ImageService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/image.service.ts